import type { LocaleKeyShape } from '../locale-key-shape'
import en from './en'
import ms from './ms'
import zh from './zh'

export type ConsoleTranslationKeys = typeof en

// `en` is the canonical key tree. The `satisfies` constraint forces `ms` and `zh`
// to carry every key `en` does (matching nesting) or `type-check` fails with
// TS2741 — this is the build-time locale-parity guard. Values stay free to be
// translated; only the key structure is enforced. A dropped/renamed key in a
// translated locale is a compile error, not a silent runtime fallback to `en`.
export const consoleTranslations = {
  en,
  ms,
  zh,
} as const satisfies Record<'en' | 'ms' | 'zh', LocaleKeyShape<typeof en>>
